import React from 'react';
import i18n from 'i18next';
import { Button } from 'reactstrap';

import SideBarIcon from '../../../assets/calendar/side-bar.svg?react';

const EventsSearchHeader = ({ onExport }) => (
  <div className="events-search-header">
    <div className="events-search-header-title-container">
      <SideBarIcon />
        <span className="events-search-header-title inter-semibold-12">
            {i18n.t('calendar.result_title')}
        </span>
    </div>
    <Button
      className="events-search-header-export-btn inter-semibold-14"
      onClick={onExport}
      title={i18n.t('calendar.export')}
    >
      {i18n.t('calendar.export')}
    </Button>
  </div>
);

export default EventsSearchHeader;
